import { api } from "../api";

export const postEndCare = async (patientId: string) => {
  // todo: specify treatment end https://github.com/mild-blue/health-warden/issues/784
  await api.services.patientCare.endCare(patientId, { treatmentEnd: new Date().toISOString() });
};
